import { useLoad } from '@gogame/query';

import { loadParentCampaign } from 'scenes/Campaigns/sources/parentCampaigns';

import { exact } from './queryKeyFactory';

export const useLoadParentCampaign = (params) => {
  return useLoad(exact(params.id), () => loadParentCampaign(params));
};
